import React from "react";
import styled from "styled-components";
import { animations } from "../../utils/animations";
import { Grid2LargeImageWrapper } from "./ImageStyles";
import breakpoints from "../../utils/breakpoints";
import setScrollPosition from "../../utils/setScrollPosition";

const Image = styled.img`
  max-width: 620px;
  width: 100%;
  height: auto;
  ${animations.image.unHover}
  &:hover {
    &:active {
      opacity: 0.7;
    }
  }

  @media ${breakpoints.tabletOnly} {
    max-width: 620px;
  }
`;

export default function ImageGrid2Large({ imageSource = null, link, altText, titleText }) {
  if (imageSource?.length === 0) {
    return <></>;
  }

  return (
    <Grid2LargeImageWrapper href={link} alt={altText} onClick={()=> setScrollPosition()}>
      <Image src={imageSource} alt={altText} title={titleText} />
    </Grid2LargeImageWrapper>
  );
}
